module.exports = __webpack_public_path__ + "static/media/hangman.fbbbf353.png";